import { supabase } from '../supabase/supabaseClient.js';

// Servicio especializado en datos de compañías
export const getCompanyById = async (companyId) => {
  try {
    const { data, error } = await supabase
      .from('companias')
      .select('*')
      .eq('id', companyId)
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error fetching company by ID:', error);
    throw error;
  }
};

export const getCompanyMetrics = async (companyId) => {
  try {
    const { data, error } = await supabase
      .from('company_dashboard_metrics')
      .select('*')
      .eq('company_id', companyId) // <-- usar company_id en esta vista
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error fetching company metrics:', error);
    throw error;
  }
};

// Nuevo servicio para obtener métricas completas del dashboard
export const getCompleteDashboardMetrics = async (companyId, dateRange = null) => {
  try {
    // Obtener métricas principales de la vista consolidada
    const { data: dashboardData, error: dashboardError } = await supabase
      .from('company_dashboard_metrics')
      .select('*')
      .eq('company_id', companyId) // <-- usar company_id en esta vista
      .single();

    if (dashboardError) throw dashboardError;

    // Obtener datos históricos para gráficos (últimos 30 días por defecto)
    const startDate = dateRange?.start || new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString();
    const endDate = dateRange?.end || new Date().toISOString();

    // Métricas históricas de sesiones
    const { data: sessionHistory, error: sessionError } = await supabase
      .from('company_sesiones')
      .select('created_at, canal')
      .eq('compania_id', companyId)
      .gte('created_at', startDate)
      .lte('created_at', endDate)
      .order('created_at', { ascending: true });

    if (sessionError) console.warn('Error fetching session history:', sessionError);

    // Métricas históricas de pagos
    const { data: paymentHistory, error: paymentError } = await supabase
      .from('company_pagos')
      .select('created_at, amount, status')
      .eq('compania_id', companyId)
      .gte('created_at', startDate)
      .lte('created_at', endDate)
      .order('created_at', { ascending: true });

    if (paymentError) console.warn('Error fetching payment history:', paymentError);

    return {
      realtime: dashboardData,
      historical: {
        sessions: sessionHistory || [],
        payments: paymentHistory || [],
        dateRange: { start: startDate, end: endDate }
      }
    };
  } catch (error) {
    console.error('Error fetching complete dashboard metrics:', error);
    throw error;
  }
};

// Servicio para obtener datos de drill-down por nivel
export const getDrillDownMetrics = async (companyId, level, parentId = null) => {
  try {
    let query = supabase.from(`company_${level}`).select('*').eq('compania_id', companyId);
    
    if (parentId) {
      // Agregar filtro por parent según el nivel
      switch (level) {
        case 'planes':
          query = query.eq('producto_id', parentId);
          break;
        case 'sesiones':
          query = query.eq('plan_id', parentId);
          break;
        case 'cotizaciones':
          query = query.eq('sesion_id', parentId);
          break;
        case 'contrataciones':
          query = query.eq('cotizacion_id', parentId);
          break;
        case 'pagos':
          query = query.eq('contratacion_id', parentId);
          break;
      }
    }

    const { data, error } = await query.order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error(`Error fetching drill-down metrics for ${level}:`, error);
    throw error;
  }
};

export default {
  getCompanyById,
  getCompanyMetrics,
  getCompleteDashboardMetrics,
  getDrillDownMetrics
};